// storage.ts
import { ref, deleteObject } from 'firebase/storage';
// Reuse the single storage instance initialised in firebase.ts
import { storage } from './firebase';

// Function to delete a file
export const deleteFile = async (filePath: string) => {
  const fileRef = ref(storage, filePath);
  try {
    await deleteObject(fileRef);
  } catch (error) {
    console.error(`Error deleting file ${filePath}:`, error);
    throw error; // Re-throw the error so it can be caught in the calling function
  }
};

export default storage;